import React, { MouseEventHandler } from 'react';
import DateNavigator from '../DateRangeSlider/DateRangeSlider';
import { getSlotIcons } from 'src/utils/helpers';
import { getTimeToShowForAvailabilityWidget } from '../../utils';
import CustomTooltip from 'src/components/base/Tooltip/Tooltip';
import { Typography } from "src/latest/src/components";
import './TherapistAvailabilitySlotContainer.scss';

import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { AvailabilitySlot } from '../../types/TherapistAvailabilityWidget';

type TherapistAvailabilitySlotContainerType = {
  availableSlotData: any;
  therapistSlotData: any;
  headingTextForAvailabilityWidget: string;
  formattedTherapistSlotData: any;
  sliderDateChange: (date: string) => void;
  bookAppointmentSlot:  (  slotData: { slot: AvailabilitySlot; date: string },
        therapistAvailableData: any,) => void;
  showMoreSlots: boolean;
  handleShowMoreSlots: MouseEventHandler;
  dropDownDisabled: boolean;
  toggleShowMoreSlots: boolean;
  hideTitle?: boolean;
  handleLaterSlot: (slotData:any) => void;
};

const TherapistAvailabilitySlotContainer: React.FC<
  TherapistAvailabilitySlotContainerType
> = ({
  availableSlotData,
  therapistSlotData,
  headingTextForAvailabilityWidget,
  formattedTherapistSlotData,
  sliderDateChange,
  bookAppointmentSlot,
  showMoreSlots,
  dropDownDisabled,
  handleShowMoreSlots,
  toggleShowMoreSlots,
  hideTitle,
  handleLaterSlot,
}) => {
  const { blackoutHours, blackoutDays, practiceTimeZone } = useSelector(
    (state: any) => state?.configuration,
  );

  return (
    <div
      className={`Therapist-slot-availability-container ${
        showMoreSlots && toggleShowMoreSlots ? 'full-height' : ''
      }`}
    >
      {availableSlotData && !hideTitle && (
        <div className="Therapist-slot-availability-container-div">
          <Typography className="Therapist-slot-availability-container-head-text">
            {headingTextForAvailabilityWidget}
          </Typography>
        </div>
      )}
      {availableSlotData &&
      availableSlotData?.date_requested_utc &&
      availableSlotData?.date_requested_utc?.length > 0 ? (
        <div className="Therapist-slot-availability-container-div Therapist-slot-availability-container-date-nav">
          <DateNavigator
            handleDateChange={sliderDateChange}
            isFromMobile={true}
            initDate={
              availableSlotData &&
              availableSlotData?.date_requested_utc &&
              availableSlotData?.date_requested_utc?.length > 0 &&
              availableSlotData?.date_requested_utc[0]
            }
            blackoutDays={blackoutDays}
            blackoutHours={blackoutHours}
            practiceTimeZone={practiceTimeZone}
            isFromQuestionnaire={false}
            classNameProps="availability-widget-date-navigator"
            fromAvailabilityWidget={true}
          />
        </div>
      ) : (
        <div className="Therapist-slot-availability-container-div Therapist-slot-availability-container-date-nav">
          <p className="availability-widget-date-navigator">
            Oops Date Range is not Available
          </p>
        </div>
      )}
      {dropDownDisabled && (
        <div className="Therapist-slot-availability-container-spinner-div">
          <Spinner
            animation="border"
            role="status"
            variant="dark"
            className="m-auto"
          />
        </div>
      )}
      {!dropDownDisabled &&
      availableSlotData &&
      availableSlotData?.match_scores &&
      availableSlotData?.match_scores?.length > 0 ? (
        <>
          {therapistSlotData &&
          therapistSlotData?.length > 0 &&
          therapistSlotData[0]?.slots_data?.length > 0 ? (
            <div
              className={`Therapist-slot-availability-container-div Therapist-slot-availability-container-tooltip-div ${
                showMoreSlots && toggleShowMoreSlots
                  ? 'tooltip-div-full-height'
                  : ''
              }`}
            >
              {formattedTherapistSlotData &&
                formattedTherapistSlotData?.length > 0 &&
                formattedTherapistSlotData?.map(
                  (formatData: any, index: number) => {
                    const date = Object.keys(formatData)[0];
                    const slotsData = formatData[date];

                    return (
                      <div
                        key={index}
                        className="Therapist-slot-availability-container-div Therapist-slot-availability-container-format-div"
                      >
                        {slotsData &&
                          slotsData?.length > 0 &&
                          slotsData?.map((slot: any, key: number) => {
                            return (
                              <div
                                key={key}
                                className="Therapist-slot-availability-container-slot-list-item"
                              >
                                <CustomTooltip
                                  force={true}
                                  htmlContent={
                                    <Typography
                                      variant="size-12"
                                      dangerouslySetInnerHTML={{
                                        __html: slot?.tool_tip as string,
                                      }}
                                    />
                                  }
                                  placement="top"
                                  className="tooltip"
                                  key={key}
                                >
                                  <div
                                    className="slot"
                                    id={`${key}`}
                                    onClick={() =>
                                      bookAppointmentSlot(
                                        { slot, date },
                                        therapistSlotData[0],
                                      )
                                    }
                                  >
                                    {getSlotIcons(slot?.meeting_pref)}

                                    <Typography
                                      variant="size-12"
                                      color="color-2"
                                      weight="semi-bold"
                                    >
                                      {slot?.slot_start_date_time
                                        ? getTimeToShowForAvailabilityWidget(
                                            slot?.slot_start_date_time,
                                          )
                                        : slot?.slot_time_str}
                                    </Typography>
                                  </div>
                                </CustomTooltip>
                              </div>
                            );
                          })}
                      </div>
                    );
                  },
                )}
            </div>
          ) : (
            !dropDownDisabled && (
              <div className="Therapist-slot-availability-container-div Therapist-slot-availability-container-no-slots">
                {therapistSlotData &&
                therapistSlotData?.length &&
                therapistSlotData[0]?.later_slot?.slot_start_date_time
                  ?.length ? (
                  <div
                    className="Therapist-slot-availability-container-later-slot"
                    onClick={() => handleLaterSlot(therapistSlotData[0])}
                  >
                    <Typography
                      variant="size-14"
                      color="color-2"
                      weight="bold"
                      className="later_slot"
                    >
                      {`Next Opening: ${moment(
                        therapistSlotData[0]?.later_slot?.slot_start_date_time,
                      ).format('ddd, MMM D, hh:mm A')}`}
                    </Typography>
                  </div>
                ) : (
                  <div className="Therapist-slot-availability-container-later-slot">
                    <Typography
                      variant="size-14"
                      color="color-2"
                      weight="bold"
                      className="later_slot"
                    >
                      {`No Openings Available`}
                    </Typography>
                  </div>
                )}
              </div>
            )
          )}
        </>
      ) : (
        !dropDownDisabled && (
          <div className="Therapist-slot-availability-container-div Therapist-slot-availability-container-no-slots">
            {therapistSlotData &&
            therapistSlotData?.length &&
            therapistSlotData[0]?.later_slot?.slot_start_date_time?.length ? (
              <div
                className="Therapist-slot-availability-container-later-slot"
                onClick={() => handleLaterSlot(therapistSlotData[0])}
              >
                <Typography
                  variant="size-14"
                  color="color-2"
                  weight="bold"
                  className="later_slot"
                >
                  {`Next Opening: ${moment(
                    therapistSlotData[0]?.later_slot?.slot_start_date_time,
                  ).format('ddd, MMM D, hh:mm A')}`}
                </Typography>
              </div>
            ) : (
              <div className="Therapist-slot-availability-container-later-slot">
                <Typography
                  variant="size-14"
                  color="color-2"
                  weight="bold"
                  className="later_slot"
                >
                  {`No Openings Available`}
                </Typography>
              </div>
            )}
          </div>
        )
      )}
      {availableSlotData &&
        availableSlotData &&
        availableSlotData?.match_scores &&
        availableSlotData?.match_scores?.length > 0 &&
        showMoreSlots && (
          <div
            onClick={handleShowMoreSlots}
            className={`Therapist-slot-availability-container-div Therapist-slot-availability-container-show-text`}
          >
            {toggleShowMoreSlots ? (
              <Typography className="Therapist-slot-availability-container-show-text-typo cursor_pointer">
                View less Availability ↑
              </Typography>
            ) : (
              <Typography className="Therapist-slot-availability-container-show-text-typo cursor_pointer">
                View More Availability ↓
              </Typography>
            )}
          </div>
        )}
    </div>
  );
};

export default TherapistAvailabilitySlotContainer;